import * as globalUtils from 'global/common/globalUtils';

const { Cookie } = window.od;

export default class ProductCompare {
	constructor() {
		this.compareCheckboxId = document.querySelectorAll('[id*="compare_"]');
		this.compareActiveContent = document.getElementById('compareContent');
		this.cookiePath = this.getCookiePath();
		this.cookieDom = {};
		this.productSku = [];
		this.finalCookieDom = {};
		this.compareCookie = { dom: {}, skus: [] };
		this.util = Object.assign({}, globalUtils);
		this.maxCompare = 3;

		if (this.cookiePath) {
			this.getCookieData();
			this.compareActive();
			this.createCompareProduct();
			this.checkCompareActive();
			this.compareUncheckRedirect();
			this.compareToggle();
		}
	}

	compareUncheckRedirect() {
		const preCheckedFalse = document.querySelectorAll('[data-checked="false"]');
		preCheckedFalse.forEach(checked => {
			checked.checked = false;
		});
	}

	getCookieData() {
		const compareName = 'ODcompare';
		const cookie = Cookie.get(compareName);

		if (cookie) {
			this.handleCookieData(cookie);
		}
	}

	handleCookieData(cookie) {
		const cookieData = JSON.parse(cookie);
		this.compareCookie = cookieData;
		this.productSku = cookieData.skus;

		if (cookieData.name === this.cookiePath && cookieData.skus.length) {
			this.prePopulateCheckBox(cookieData.skus);
		} else {
			this.clearAll();
		}

		this.compareSubmitBtn();
		this.disableCheckbox();
	}

	prePopulateCheckBox(skus) {
		this.compareCheckboxId.forEach(compareCheckbox => {
			const cookieGet = compareCheckbox.getAttribute('data-compare-sku');

			skus.forEach(sku => {
				if (cookieGet === sku) {
					compareCheckbox.setAttribute('checked', 'checked');
					compareCheckbox.setAttribute('data-checked', 'true');
				}
			});
		});
	}

	checkCompareActive() {
		if (this.productSku.length > 0) {
			this.compareActiveContent.setAttribute('data-toggle-show', 'true');
			this.clearAllAction();
		} else {
			this.compareActiveContent.setAttribute('data-toggle-show', 'false');
		}
	}

	compareActive() {
		this.compareCheckboxId.forEach(compareCheckbox => {
			compareCheckbox.addEventListener('click', e => {
				const selectedCheckBox = e.target.getAttribute('data-checked');

				if (selectedCheckBox === 'false') {
					e.target.setAttribute('data-checked', true);
				} else {
					e.target.setAttribute('data-checked', false);
				}

				this.createCookieDom(e.target);
				this.checkCompareActive();
				this.disableCheckbox();
			});
		});
	}

	disableCheckbox() {
		this.compareCheckboxId.forEach(compareCheckbox => {
			const unchecked = compareCheckbox.getAttribute('data-checked');

			if (this.productSku.length >= this.maxCompare) {
				if (unchecked === 'false') {
					compareCheckbox.setAttribute('disabled', 'disabled');
				}
			} else {
				compareCheckbox.removeAttribute('disabled');
			}
		});
	}

	compareSubmitBtn() {
		const compareBtn = document.getElementById('compareAction');
		if (this.productSku.length > 1) {
			compareBtn.classList.remove('disabled');
		} else {
			compareBtn.classList.add('disabled');
		}
	}

	clearAll() {
		const compareCheckboxChecked = document.querySelectorAll(
			'[id*="compare_"]:checked',
		);

		compareCheckboxChecked.forEach(compareCheckbox => {
			compareCheckbox.checked = false;
			compareCheckbox.setAttribute('data-checked', 'false');
		});

		this.compareCheckboxId.forEach(checkboxId => {
			checkboxId.removeAttribute('disabled');
		});

		this.compareActiveContent.setAttribute('data-toggle-show', 'false');
		this.unsetCookie(this.productSku, this.compareCookie.dom);
		this.createCookie();
	}

	clearAllAction() {
		const clearAllBtn = document.getElementById('compareClearAll');

		clearAllBtn.addEventListener('click', e => {
			e.preventDefault();
			this.clearAll();
		});
	}

	compareToggle() {
		const toggleBtn = document.getElementById('compareToggle');
		const compareProductsContent = document.getElementById(
			'compareProductsContent',
		);
		const compareContent = document.getElementById('compareContent');

		toggleBtn.addEventListener('click', () => {
			const contentHeight = compareProductsContent.offsetHeight;

			if (compareContent.style.bottom === `-${contentHeight}px`) {
				compareContent.style.bottom = '0px';
				toggleBtn.setAttribute('data-compare-show', 'true');
			} else {
				compareContent.style.bottom = `-${contentHeight}px`;
				toggleBtn.setAttribute('data-compare-show', 'false');
			}
		});
	}

	getCookiePath() {
		const pathId = document.getElementById('productList');
		if (pathId) {
			return pathId.getAttribute('data-compare-path-id');
		}

		return null;
	}

	createCookieDom(productData) {
		const dataSku = productData.getAttribute('data-compare-sku');
		const dataImg = productData.getAttribute('data-compare-image');
		const dataTitle = productData.getAttribute('data-compare-title');

		if (Object.hasOwnProperty.call(this.compareCookie.dom, dataSku)) {
			this.unsetCookie(dataSku, this.compareCookie.dom);
		} else {
			this.cookieDom = {
				[dataSku]: {
					skuId: dataSku,
					imgUrl: dataImg,
					productTitle: encodeURIComponent(dataTitle),
				},
			};

			this.productSku.push(dataSku);
		}
		this.finalCookieDom = Object.assign(this.compareCookie.dom, this.cookieDom);
		this.createCookie();
	}

	createCookie() {
		const cookieDomData = JSON.stringify(this.finalCookieDom);
		const productSku = JSON.stringify(this.productSku);
		document.cookie = `ODcompare={"name":"${this.cookiePath}","dom":${cookieDomData}, "skus":${productSku}};sameSite=strict;secure;path=/`;

		if (this.productSku.length > 0) {
			this.createCompareProduct();
		}
	}

	unsetCookie(dataSku, prevCookieDom) {
		this.cookieDom = {};

		if (typeof dataSku === 'string') {
			delete prevCookieDom[dataSku];
			const skuIndex = this.productSku.indexOf(dataSku);
			this.productSku.splice(skuIndex, 1);
			this.finalCookieDom = prevCookieDom;
		} else {
			dataSku.forEach(dataSkuItem => {
				delete prevCookieDom[dataSkuItem];
			});

			this.productSku = [];
		}
	}

	createCompareProduct() {
		this.getCookieData();
		const compareSkus = this.compareCookie || {};
		const compareProducts = document.getElementById('compareProducts');

		compareProducts.innerHTML = '';

		compareSkus.skus.forEach(compareSku => {
			compareProducts.appendChild(
				this.createCompareBlock(this.compareCookie.dom[compareSku]),
			);
		});

		if (compareSkus.skus.length < this.maxCompare) {
			const emptySku = this.maxCompare - compareSkus.skus.length;
			for (let i = 0; i < emptySku; i += 1) {
				compareProducts.appendChild(this.createEmptyBlock());
			}
		}

		this.compareRemove();
	}

	createCompareBlock(productData) {
		const translation = document
			.getElementById('compareProducts')
			.getAttribute('data-sr-only-remove');

		const productBlock = `<div class="product-compare__product">
				<button id="compareRemove_${productData.skuId}" data-remove-sku="${
					productData.skuId
				}" class="product-compare__remove">
					<span class="sr-only">${translation}</span>
				</button>
				<img class="product-compare__img img-responsive" src="${
					productData.imgUrl
				}?wid=100&hei=100">
				<p class="product-compare__title">${decodeURIComponent(
					productData.productTitle,
				)}</p>
			</div>`;

		return this.util.getNodeFromString(productBlock);
	}

	createEmptyBlock() {
		const emptyBlock =
			'<div class="product-compare__product product-compare__product--empty"></div>';

		return this.util.getNodeFromString(emptyBlock);
	}

	compareRemove() {
		const removeBtn = document.querySelectorAll('[id*="compareRemove_"]');
		removeBtn.forEach(btn => {
			btn.addEventListener('click', e => {
				const removeId = e.currentTarget.getAttribute('data-remove-sku');
				this.removeSingle(removeId);
			});
		});
	}

	removeSingle(sku) {
		const compareCheckbox = document.querySelectorAll('[data-compare-sku]');

		compareCheckbox.forEach(checkbox => {
			const compareUnCheck = checkbox.getAttribute('data-compare-sku');

			if (compareUnCheck === sku) {
				checkbox.checked = false;
				checkbox.setAttribute('data-checked', 'false');
			}
		});

		this.compareCheckboxId.forEach(compareCheckboxId => {
			compareCheckboxId.removeAttribute('disabled');
		});

		this.unsetCookie(sku, this.compareCookie.dom);
		this.createCookie();
		this.createCompareProduct();

		if (this.productSku.length <= 0) {
			this.compareActiveContent.setAttribute('data-toggle-show', 'false');
		}
	}
}
